module.exports = "/_next/static/images/mobile-hero-image-721b4ec91cd6d97790ac3aa0c1e17734.png";